ACC.overlayItems = {
  bindAll: function() {
    ACC.overlayItems.hideChatForAnon();
  },
  hideChatForAnon: function() {
    if ($('.chatButtonClass').length > 0 && $('.ph-loggedInPage__genericClass').length === 0) {
      $('.chatButtonContainer').remove();
    }
  }
};
$(document).ready(function() {
  ACC.overlayItems.bindAll();
});
